import AdvancementIcon from '../img/advancement.svg';
import EngagementIcon from '../img/engagement.svg';
import HappinessIcon from '../img/happiness.svg';
import RelationshipsIcon from '../img/relationships.svg';
import StrengthIcon from '../img/strength.svg';
import TruthIcon from '../img/truth.svg';

export enum CategoryName {
  Happiness = 'Happiness',
  Engagement = 'Engagement',
  Advancement = 'Advancement',
  Relationships = 'Relationships',
  Truth = 'Truth',
  Strength = 'Strength',
}

export const STEPS = ['start', 'card-sorting', 'fulfillment'];

export const CATEGORY_ICON_MAP = {
  [CategoryName.Happiness]: HappinessIcon,
  [CategoryName.Engagement]: EngagementIcon,
  [CategoryName.Advancement]: AdvancementIcon,
  [CategoryName.Relationships]: RelationshipsIcon,
  [CategoryName.Truth]: TruthIcon,
  [CategoryName.Strength]: StrengthIcon,
};
